import { TTintSettings } from '../types/tint-settings.type';
import { TTintColor } from '../types/tint-color.type';

type TRobotintOptions = {
  tintSettings: TTintSettings;
  siteSettings: {
    colorSelect: (color: Required<TTintColor>) => void;
    processPrice: (
      priceElement: HTMLElement[],
      tintDataObject: {
        BASE_TYPE_INT: number;
      }
    ) => void;
    bgZindex: number;
    basketURL: string;
  };
};

export class Robotint {
  enableButtons = () => {
    window.obColorer?.enableButtons();
  };

  closeModal = () => {
    window.obColorer?.close();
  };

  openModal = (currentTarget: (EventTarget & HTMLElement) | undefined) => {
    window.obColorer?.show(currentTarget);
  };

  setOptions = (robotintOptions: TRobotintOptions) => {
    window.obColorer?.setOptions(robotintOptions);
  };
}

export const robotint = new Robotint();
